import { render, staticRenderFns } from "./learnBooklistBox.vue?vue&type=template&id=72cd09ac&scoped=true&"
import script from "./learnBooklistBox.vue?vue&type=script&lang=js&"
export * from "./learnBooklistBox.vue?vue&type=script&lang=js&"
import style0 from "./learnBooklistBox.vue?vue&type=style&index=0&id=72cd09ac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cd09ac",
  null
  
)

export default component.exports